import { createFileRoute } from "@tanstack/react-router";
import { KnowledgeItemReader } from "@/components/views/knowledge/KnowledgeItemReader";

export const Route = createFileRoute("/knowledge/$itemId")({
  component: KnowledgeItemRoute,
});

function KnowledgeItemRoute() {
  const { itemId } = Route.useParams();
  return <KnowledgeItemReader itemId={itemId} />;
}
